﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {PermitResult, permitStatusName, PermitStatusType} from "@2d-front-monorepo/permits-business";
import {JSX} from "react";


export default function PermitStatusReason({permit}: { permit: PermitResult }): JSX.Element {
	const {type: statusType, reason: statusReason} = permit.status;
	const hasReason = !isNullOrEmpty(statusReason) && (statusType === PermitStatusType.RequestMoreInformation || statusType === PermitStatusType.Rejected);

	if (hasReason) {
		return (
			<div className={"status-reason status-reason--" + permitStatusName(statusType)}>{statusReason}</div>
		);
	}

	return <></>;
}
